import { render, staticRenderFns } from "./editRosterTemplateDialog.vue?vue&type=template&id=663cd51c&"
import script from "./editRosterTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./editRosterTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663cd51c')) {
      api.createRecord('663cd51c', component.options)
    } else {
      api.reload('663cd51c', component.options)
    }
    module.hot.accept("./editRosterTemplateDialog.vue?vue&type=template&id=663cd51c&", function () {
      api.rerender('663cd51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Roster/RosterTemplate/components/editRosterTemplateDialog.vue"
export default component.exports